import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import RadioBoxViewModelType from '@/ViewModels/Controls/RadioBoxViewModel';
import LabelType from '@/Controls/Label';

export default class RadioBox extends Control {

    private Label = ComponentManager.getControl<typeof LabelType>('Label');
    private jQueryControl: JQuery;
    private label: LabelType;

    public constructor(private viewModel: RadioBoxViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div><input type="radio"></div>');

        this.widget(null);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'radiobox',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            invalid: this.viewModel.invalidationText,

            visible: this.viewModel.isVisible,

            styles: this.definePureComputed({
                read: () => {
                    let styles = ['default'];

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isValid() === true) {
                        states.push('valid');
                    } else {
                        states.push('invalid');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            })
        });

        this.applyBindings(this.jQueryControl.find('input'), {
            checked: this.viewModel.checked,

            enable: this.viewModel.isEnabled,

            locator: this.viewModel.locator,

            attr: {
                id: this.identifier,

                name: this.viewModel.name,

                value: this.viewModel.value
            }
        });

        if (this.viewModel.label != null) {
            this.label = new this.Label(this.viewModel.label, $('<label for="' + this.identifier + '">').appendTo(this.jQueryControl));
            let tuple = this.label.getTuple();
        }
    }
}

ComponentManager.setControl('RadioBox', RadioBox, 'RADPresentation.HTMLClient.DefaultViewExtensions');